'use strict';

var cleanStack = require('clean-stack');
var mimicFn = require('mimic-fn');
var addErrorProps = require('./add-error-props');
var _require = require('./helpers'),
  isString = _require.isString;
function createExtendError(ErrorClass, classProps) {
  function ExtendError(props) {
    var error = new ErrorClass();
    var errorProps = isString(props) ? {
      message: props
    } : props;
    addErrorProps(error, classProps, errorProps);
    error.stack = typeof error.stack === 'string' ? cleanStack(error.stack) : undefined;
    return error;
  }
  ExtendError.prototype = ErrorClass.prototype;
  mimicFn(ExtendError, ErrorClass);
  return ExtendError;
}
module.exports = createExtendError;